import React from 'react';
import { CloseIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Close';
import { WavingHandIcon } from './WavingHandIcon';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import { styles } from './RedirectWelcomeAlert.css';

export type RedirectWelcomeAlertProps = {
  heading: React.ReactNode | string;
  content: string;
  isVisible: boolean;
  onClose: () => void;
};

export const RedirectWelcomeAlert: React.FC<RedirectWelcomeAlertProps> = ({ heading, content, isVisible, onClose }) => {
  return (
    <div className={`${styles.redirectAlertContainer} ${isVisible ? styles.visible : ''}`}>
      <WavingHandIcon className={styles.handIcon} />
      <JBButton type="iconOnly" icon={<CloseIcon />} classes={styles.btnClose} onClick={onClose} />
      <h3 className={styles.heading}>{heading}</h3>
      <p className={styles.content}>{content}</p>
      <JBButton type="action" onClick={onClose} label="Got it" fullWidth />
    </div>
  );
};
